var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlockRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8314 9.17969H17.5979C19.2197 9.17969 20.5391 10.4939 20.5391 12.1094V22.0703C20.5391 23.6857 19.2197 25 17.5979 25H3.48024C1.85847 25 0.539062 23.6857 0.539062 22.0703V12.1094C0.539062 10.4939 1.85847 9.17969 3.48024 9.17969H5.24313V5.16455C5.24313 2.3168 7.61808 0 10.5372 0C13.4564 0 15.8314 2.3168 15.8314 5.16455V9.17969ZM10.5372 1.95312C8.69926 1.95312 7.20392 3.39375 7.20392 5.16455V9.17969H13.8706V5.16455C13.8706 3.39375 12.3752 1.95312 10.5372 1.95312ZM17.5979 23.0469C18.1385 23.0469 18.5783 22.6088 18.5783 22.0703V12.1094C18.5783 11.5709 18.1385 11.1328 17.5979 11.1328H3.48024C2.93965 11.1328 2.49985 11.5709 2.49985 12.1094V22.0703C2.49985 22.6088 2.93965 23.0469 3.48024 23.0469H17.5979ZM8.72534 15.7715C8.72534 14.7737 9.53735 13.9648 10.5391 13.9648C11.5408 13.9648 12.3528 14.7737 12.3528 15.7715C12.3528 16.4102 12.0198 16.9709 11.5176 17.2922V19.4336C11.5176 19.9729 11.0787 20.4102 10.5372 20.4102C9.99578 20.4102 9.55686 19.9729 9.55686 19.4336V17.2899C9.05671 16.9683 8.72534 16.4086 8.72534 15.7715Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockRed);
export default __webpack_public_path__ + "static/media/padlockRed.befa70ef3a94bbf3323ca6acd4facaa6.svg";
export { ForwardRef as ReactComponent };